export default __webpack_public_path__ + "static/media/ricardo.6e172674.jpeg";